import React from 'react';
import cx from 'classnames';
import { COPY_STRINGS } from '../constants/translatedCopy';
import ListeningStatus from './Global/ListeningStatus';
import { getUserData } from "../services/API";

export default function WordInfoInterventionModal({ word, instructions, numberOfSounds, forceVertical }) {
  let wordClasses = cx({
    'word': true,
    'longWord': word ? (word.length > 8) : false,
  });

  let containerClasses = cx({
    wordInterventionModal: true,
    wordInfoInterventionModal: true,
    vertical: getUserData().sessionData.isiPad,
  });

  //Avoid miscalculation on words like "didn't"
  const cleanWord = word.replace(/[.,\/#!$%\^&\*;:{}=\_`'~()""?!]/g, "");

  return (
    <div className={containerClasses}>
      <div className="left">
        <div className="wordInfoBox">
          <div className="wordInfo">
            <span className="bold">{cleanWord.length}</span>{" "}
            {COPY_STRINGS.intervention_strings.letters}
          </div>
          <div className="wordInfo">
            <span className="bold">{numberOfSounds}</span>{" "}
            {COPY_STRINGS.intervention_strings.sounds}
          </div>
        </div>
      </div>
      <div className="right">
        <div className="instructions">{instructions}</div>
        <div className={wordClasses}>{word}</div>
        <div className="listeningStatusWrapper">
          <ListeningStatus />
        </div>
      </div>
    </div>
  );
}